module.exports = __webpack_public_path__ + "static/media/2.2d473642.svg";